import { makeStylesheetLink } from "../stylesheet";

export class RedirectButton extends HTMLElement {

	shadow: ShadowRoot;

	button: HTMLButtonElement;

	onClick: () => void;

	constructor() {
		super();

		this.shadow = this.attachShadow({ mode: "open" });

		this.button = <button type="button" /> as HTMLButtonElement;

		this.onClick = onClick.bind(this);

		this.shadow.append(
			this.button,
			makeStylesheetLink()
		);
	}

	connectedCallback() {
		this.button.className = this.dataset.class ?? "";
		this.button.innerHTML = this.dataset.label ?? "";
		this.button.addEventListener("click", this.onClick);
	}

	disconnectedCallback() {
		this.button.removeEventListener("click", this.onClick);
	}
}

async function onClick(this: RedirectButton) {
	try {
		this.button.disabled = true;
		window.location.href = this.dataset.url!;
	} finally {
		this.button.disabled = false;
	}
}
